import { RouteRecordRaw } from "vue-router";
import SignUpRoutes from "@/modules/dashboard/signup/routes";

export default [
  ...SignUpRoutes,
] as Array<RouteRecordRaw>;
